import { BaseExternalBankAccount, baseExternalBankAccountToJson } from '@klear/bank-account/base'

export function supplierExternalBankAccountToJson(account: SupplierExternalBankAccount) {
  return {
    ...baseExternalBankAccountToJson(account),
    supplierId: account.supplierId
  }
}
export type SupplierExternalBankAccountJson = ReturnType<typeof supplierExternalBankAccountToJson>

export class SupplierExternalBankAccount extends BaseExternalBankAccount {
  static readonly __klearClass = 'SupplierExternalBankAccount'

  supplierId: number

  constructor(props: SupplierExternalBankAccountJson) {
    super(props)
    this.supplierId = props.supplierId
    this.assertValid()
  }

  assertValid(): void {
    if (!this.supplierId) {
      throw new Error('SupplierExternalBankAccount supplierId is required')
    }
    if (!this.organizationId) {
      throw new Error('SupplierExternalBankAccount organizationId is required')
    }
  }

  toJSON() {
    return supplierExternalBankAccountToJson(this)
  }
}
